module.exports = __webpack_public_path__ + "static/1304429049.83deba21.jpg";